import { Card, SerializableCard } from "./Card";

export class StackCard {
    public card: Card;
    public count: number;

    constructor(card: Card, count: number) {
        this.card = card;
        this.count = count;
    }

    public convertToSerializableCard(): SerializableCard[] {
        const card = this.card;
        const cards: SerializableCard[] = [];
        for (let index = 0; index < this.count; index++) {
            cards.push(card.convertToSerializableCard());
        }
        return cards;
    }
}